import { createContext } from 'react';
import type { Business, Event, Artist } from '@/features/clubs/types/types';

export interface ClubContextType {
  // Cache for club data by handle
  clubCache: Map<string, Business>;
  // Cache for events by handle
  eventsCache: Map<string, Event[]>;
  // Cache for artists by handle
  artistsCache: Map<string, Artist[]>;
  // Loading states for each club
  loadingStates: Map<string, boolean>;
  // Error states for each club
  errorStates: Map<string, string | null>;
  // Current active club handle
  currentClubHandle: string | null;

  // Methods
  getClubData: (handle: string) => Business | null;
  getClubEvents: (handle: string) => Event[] | null;
  getClubArtists: (handle: string) => Artist[] | null;
  fetchClubData: (handle: string) => Promise<Business | null>;
  fetchClubEvents: (handle: string) => Promise<Event[] | null>;
  fetchClubArtists: (handle: string) => Promise<Artist[] | null>;
  isLoading: (handle: string) => boolean;
  getError: (handle: string) => string | null;
  clearCache: () => void;
  clearClubCache: (handle: string) => void;
  setCurrentClub: (handle: string) => void;
  invalidateOtherClubs: (currentHandle: string) => void;
  clearCurrentClub: () => void;
  clearCacheOnNavigation: () => void;
}

export const ClubContext = createContext<ClubContextType | undefined>(undefined);
